import React from "react";
import { useAppContext } from "../helpers/account-context";

import { HoursInfowin } from "./Components/HoursInfo";
import { CtaInfowin } from "./Components/CtaInfo";
import { FieldsInfowin } from "./Components/FieldsInfo";
import { ActionsInfowin } from "./Components/ActionsInfo";
import { SocialsInfowin } from "./Components/SocialsInfo";
import { HeroInfowin } from "./Components/HeroInfo";
import { CustomFieldsInfowin } from "./Components/CustomFieldsInfo";
import { TagsInfowin } from "./Components/TagsInfo";
import { DirectionInfowin } from "./Components/DirectionInfo";
import { HorizonalLine } from "./Components/Mixin";
import { DistanceInfowin } from "./Components/DistanceInfo";
import { ViewDetailsInfowin } from "./Components/ViewDetailsInfo";
import { hexToRGB } from "../helpers/sharedUtils";

const InfoRow = (props) => {
  const { item, fieldName } = props;
  if (fieldName === "name" || fieldName === "location_type_name")
    return (
      <FieldsInfowin {...props} fieldName={fieldName} hiddenLabel={true} />
    );

  if (fieldName === "hours") return <HoursInfowin {...props} />;
  if (fieldName === "actions") return <ActionsInfowin {...props} />;
  if (fieldName === "socials") return <SocialsInfowin {...props} />;
  if (fieldName === "cta_buttons") return <CtaInfowin {...props} />;
  if (fieldName === "custom_fields") return <CustomFieldsInfowin {...props} />;
  if (fieldName === "distance") return <DistanceInfowin {...props} />
  if (fieldName === "tags") return <TagsInfowin {...props} />;
  if (fieldName === "directions") return <DirectionInfowin {...props} />;
  if (fieldName === "view_details") return <ViewDetailsInfowin {...props} />;
  if (fieldName && !!fieldName.match(/hr\d{1}/i))
    return <HorizonalLine {...props} />;
  if (!item.properties[fieldName]) return null;
  return <FieldsInfowin {...props} fieldName={fieldName} hiddenLabel={true} /> 
};

export const InfoWindow = (props) => {
  const { account } = useAppContext()
  const { selectedLocation, hoveredLocation, item, onClose, onHoverLocation  = console.log } = props;
  const { info_window = {} } = account;

  // if(info_window && !info_window.infowin_enabled) return null;
  const { fields = [], hero_position} = (info_window || {});

  const isVisible = props.isVisible || (selectedLocation || hoveredLocation);
  const infoWindowStyle = {
    opacity: isVisible ? 1 : 0,
    display: isVisible ? 'block' : 'none'
  };

  return (
    <div 
      className={`cbmap-infowin-wrapper cbmap-hero-pos_${hero_position}`} 
      style={infoWindowStyle}
      onMouseEnter={onHoverLocation}
    >
      {selectedLocation && (
        <div className="cbmap-infowin-btn-close" onClick={onClose}>
          &times;
        </div>
      )}

      <div
        className={`cbmap-infowin-content cbmap-scrollable cbmap-hero-pos_${hero_position}`}
      >
        {!!hero_position &&
          hero_position !== "hidden" && (
            <HeroInfowin fieldName="hero" {...props} />
          )}
        <div className="cbmap-infowin-props">
          {fields.map((fieldName) => (
            <InfoRow
              key={`info-row-${fieldName}`}
              item={item}
              fieldName={fieldName}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export const GMarker = (props) => {
  const {
    place,
    onClose,
    selectedLocation,
    hoveredLocation,
    onHoverLocation,
    onSelectLocation,
    settings,
    hideInfo = false,
    
  } = props;
  const { account } = useAppContext()
  const { info_window = {}, clusters = {} } = account;
  const animationEnabled = true && settings && settings.animation_enabled
  const show = selectedLocation?.properties.uid === place.properties.uid
  const hovering = hoveredLocation?.properties.uid === place.properties.uid;
  const markerIcon = !!place.properties.marker_url ? place.properties.marker_url :
    "https://cbmap-prod.s3.us-west-1.amazonaws.com/markers/maker-100-new-26.png";
  const isVisible = (show || (clusters.marker_hovering && hovering));

  return (
    <div
      className={`cbmap-marker ${
        hovering ? "is-hovering" : ""
      } ${show ? 'is-showing' : ''} cbmap-marker_infowin-${info_window.infowin_enabled ? 'enabled' : 'disabled'}`}
      onMouseLeave={(e) => onHoverLocation(null)}
    >
      <div className={`cbmap-marker-icon  cbmap-marker-size_${clusters.marker_size || 'small'}`}>
        <button
          className={`cbmap-marker-icon-btn ${animationEnabled ? '' : 'animation-disabled'}`}
          onClick={(e) => onSelectLocation(e)}
          type="button"
          onMouseEnter={(e) => onHoverLocation(place)}
        >
          <img src={markerIcon} alt="marker" className="cbmap-marker-icon-img" />
        </button>
      </div>
      {
        !hideInfo && isVisible && <InfoWindow
        selectedLocation={selectedLocation}
        hoveredLocation={hoveredLocation}
        item={place}
        onClose={onClose}
        onHoverLocation={(e) => onHoverLocation(place)}
      />
      }
      
    </div>
  );
};

export const ClusterMarker = (props) => {
  const { settings, points, onClick, cluster } = props;

  const { point_count: pointCount } = cluster.properties;
  const clusterSize = 40 + (pointCount / points.length) * 3 * 40;
  const styles = {
    width: `${clusterSize}px`,
    height: `${clusterSize}px`,
    boxShadow: `0px 0px 2px 4px ${hexToRGB(settings.bg_color, 0.5)}`
  };

  if (settings.bg_color) {
    styles.backgroundColor = settings.bg_color;
  }
  if (settings.color) {
    styles.color = settings.color;
  }

  return (
    <div onClick={onClick} className={`cbmap-cluster`}>
      <div className="cbmap-cluster-inner">
        <div className="cbmap-cluster-marker" style={styles}>
          {pointCount}
        </div>
      </div>
    </div>
  );
};

export const GeoMarker = (props) => {
  const { getLocale } = useAppContext()

  return (

    <div className="cbmap-geo" title={getLocale('your_location')}>
      <div className="cbmap-geo-inner"/>
    </div>

  )
}